<div class="award-card mb-4">
    <div class="card card-content h-100 border border-babyShark p-4">
        <div class="d-flex">
            <div class="image-container">
                <img [src]="imageUrl" alt="award-image" class="card-img-top">
            </div>
            <div class="award-content">
                <h5 class="font-size-14 color-whaleTail">{{ awardName }}</h5>
                <p class="card-text flex-grow-1 font-size-12 color-whaleTail">{{ awardDescription }}</p>
                <div class="reward">
                    <div class="d-flex mr-3">
                        <span style="vertical-align: text-bottom;">
                            <svg class="icon-16 fill-midas">
                                <use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                            </svg>
                        </span>
                        <span class="ml-2 font-size-14">{{ coinAmount }}</span>
                    </div>
                    <div class="d-flex">
                        <span style="vertical-align: text-bottom;">
                            <svg class="icon-16 fill-whaleTail">
                                <use href="../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use>
                            </svg>
                        </span>
                        <span class="ml-2 font-size-14">{{ xpQuantity }}</span>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <span class="font-size-12">{{ getAwardCount() }}</span>
                        <span class="ml-2 font-size-12 color-valyrianSteel">{{ getAwardPeriodMessage() }}</span>
                    </div>
                    <button type="button" class="btn btn-primary" (click)="giveAward();" [disabled]="isGivingAward || isButtonDisabled()">
                        <ng-container *ngIf="!isGivingAward">
                            <span runat="server" cvLocalizedText langSection="Manual_Awards_Context_Menu" langKey="Give_Award">Give Award</span>
                        </ng-container>
                        <ng-container *ngIf="isGivingAward">
                            <span runat="server" cvLocalizedText langSection="Common" langKey="Loading">Loading...</span>
                        </ng-container>
                    </button>

                </div>
            </div>
        </div>
    </div>
</div>